// Which rows Diagnostics reads (decision 0037). `site` is the Hotel site view:
// hotels measured on their own websites, with the widget open, from
// `site_runs`. Anything else is Direct, the sample on bw3, from `runs`.
//
// From the address bar, and only on /diagnostics: the Overview and Progress
// never send it, whatever a link says.

let router = null

/** Called once from main.js. */
export function bindScopeToRouter(instance) {
  router = instance
}

/** 'site' on Diagnostics' Hotel site view, otherwise null. */
export function scope() {
  const route = router?.currentRoute.value
  return route?.path === '/diagnostics' && route.query.scope === 'site' ? 'site' : null
}
